import React from 'react';
import { Link } from 'react-router-dom';
import s from './NotFound404.module.scss';
import img from '../../assets/Unauthorised401.svg';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';

const NotFound404 = () => (
  <div className={s.notFound404} >
    <div className={s.container}>
      <img src={img} />
      <h1>
        <FormattedMessage id="notFound404.error404" defaultMessage="Error 404" />
      </h1>
      <h5 className={s.subHeading}>
        <FormattedMessage id="notFound404.youAreNotFound404" defaultMessage="This page cannot be found" />
      </h5>
      <Link to={`/`}>
        <Button className={s.btnChange}>
          <FormattedMessage id="notFound404.returnHome" defaultMessage="Return Home" />
        </Button>
      </Link>
    </div>
  </div>
);
export default NotFound404
